import { Link } from 'react-router-dom';
import { useCrossMarketStatus } from '../../hooks/useCrossMarketStatus';
import type { CrossMarketStatus } from '../../services/crossMarketApi';
import SystemWatchlistPanel from '../system/SystemWatchlistPanel';
import {
  BLOCKER_LABELS,
  gateDetail,
  liveOrderDetail,
  livePnlDetail,
  loopValue,
  ownershipDetail,
  sampleDetail,
  shadowDetail,
  shadowLiveDetail,
  switchDetail,
  watchlistDetail,
  watchlistValue,
} from './krStrategyLabels';

export default function KrStrategyExecutionPanel() {
  const { data, loading, error, reload } = useCrossMarketStatus();
  const kr = data?.markets.KR;
  const readiness = kr?.live_readiness;

  return (
    <>
      <section className="execution-summary">
        <Summary label="Watchlist" value={watchlistValue(readiness)} />
        <Summary label="실행 루프" value={loopValue(kr?.stage)} />
        <Summary label="주문 권한" value={orderValue(data)} />
        <Summary label="검증 단계" value={readiness?.status === 'ready_locked' ? 'GO 직전 잠금' : 'Readiness 차단'} />
      </section>
      <div className="kr-execution-warning">
        <strong>{readiness?.status === 'ready_locked' ? 'KR 실주문 전환 전 마지막 잠금 상태입니다.' : 'KR 자동 실행은 아직 차단 상태입니다.'}</strong>
        <p>
          실제 주문 스위치는 꺼져 있습니다. 아래 값은 운영 API와 DB에서 읽은 현재
          readiness이며, 데이터가 없으면 그대로 데이터 없음으로 표시합니다.
        </p>
      </div>
      <SystemWatchlistPanel />
      <section className="kr-execution-card">
        <div className="kr-readiness-head">
          <h3>KR Live Readiness</h3>
          <button onClick={reload} disabled={loading}>
            {loading ? '확인 중...' : '상태 새로고침'}
          </button>
        </div>
        {error && <p className="kr-readiness-error">API 오류: {error}</p>}
        <div className="kr-readiness-grid">
          <ReadinessItem label="Toss 검증 후보" value={watchlistDetail(readiness)} />
          <ReadinessItem label="기존 보유주" value={ownershipDetail(readiness)} />
          <ReadinessItem label="KR Replay 표본" value={sampleDetail(kr)} />
          <ReadinessItem label="K2 성과 gate" value={gateDetail(kr)} />
          <ReadinessItem label="S1 Live Shadow" value={shadowDetail(kr)} />
          <ReadinessItem label="Live 주문 요약" value={liveOrderDetail(kr)} />
          <ReadinessItem label="KR 보유 PnL" value={livePnlDetail(kr)} />
          <ReadinessItem label="Shadow-Live 차이" value={shadowLiveDetail(kr)} />
          <ReadinessItem label="주문 스위치" value={switchDetail(data)} />
        </div>
        <BlockerList blockers={readiness?.blockers || []} />
        <Link className="kr-execution-link" to="/backtest">
          백테스트 화면에서 KR replay 실행
        </Link>
      </section>
    </>
  );
}

function Summary({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <span className="summary-label">{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

function ReadinessItem({ label, value }: { label: string; value: string }) {
  return (
    <div className="kr-readiness-item">
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

function BlockerList({ blockers }: { blockers: string[] }) {
  if (blockers.length === 0) {
    return <p className="kr-readiness-ok">남은 blocker 없음. 단, 실제 주문은 별도 GO 전까지 잠금 유지.</p>;
  }
  return (
    <div className="kr-readiness-blockers">
      <strong>남은 blocker</strong>
      <ul>{blockers.map((item) => <li key={item}>{BLOCKER_LABELS[item] || item}</li>)}</ul>
    </div>
  );
}
function orderValue(data: CrossMarketStatus | null) {
  return switchDetail(data);
}
